import { LogoZattiniName, LogoNetshoesName, LogoKabum, LogoEpocaName } from '@magalu/stereo-ui-icons';
export default {
  zattini: {
    id: 'zattini',
    logo: LogoZattiniName
  },
  netshoes: {
    id: 'netshoes',
    logo: LogoNetshoesName
  },
  kabum: {
    id: 'kabum',
    logo: LogoKabum
  },
  'epocacosmeticos-integra': {
    id: 'epoca',
    logo: LogoEpocaName
  }
};